// @flow

import { translate } from '@tectonics/translate';
import { type WithholdTaxes } from './types';

export function formatWithholdTaxesInstructionTextCertificate(withholdTaxes: WithholdTaxes): string {
  return translate('volcanes.payment-methods.banktransfer.debin.instructionTextCertificate', {
    merchantName: withholdTaxes.merchantName,
  });
}
